const {
  getLocation,
  getHistory,
  parseQueryString,
  createNewQueryString,
  clearFromQueryString
} = require("../../../../utils/location");

const isQueryStringEmpty = str => {
  const _str = (str || '').trim();
  const emptyValues = ['', '?', '?='];
  return emptyValues.some(v => v === _str);
}

// LADF - LINES AGGS DYNAMIC FILTERS
const CACHE = {
  FILTERS: {},
  isLoaded: false,
  URL_ROOT_KEY: 'LADF',
};

// WARNING - this code cannot work for NA, so we are currently ignoring NA values (pm or ct who are the user NA)
const isNA = (item) => {
  const parts = [item?.pmName, item?.pmUserid, item?.ctName, item?.ctUserid].filter(v => v);
  return parts.some(p => p === 'NA');
}

const _addToLocal = (filterKey, item) => {
  CACHE.FILTERS[filterKey] = CACHE.FILTERS[filterKey] || [];
  if (!isNA(item)) { 
    CACHE.FILTERS[filterKey].push(item.id);
  }
};

const _removeFromLocal = (filterKey, item) => { 
  CACHE.FILTERS[filterKey] = CACHE.FILTERS[filterKey] || [];  
  CACHE.FILTERS[filterKey] = CACHE.FILTERS[filterKey].filter(id => id !== item.id);
  if (CACHE.FILTERS[filterKey].length === 0) {
    delete CACHE.FILTERS[filterKey];
  }
};

const _clearLocal = () => { 
  CACHE.FILTERS = {};
}

const loadCacheFromUrl = () => {
  const location = getLocation();
  const urlparams = parseQueryString(location?.search) || {};
  CACHE.FILTERS = JSON.parse(urlparams[CACHE.URL_ROOT_KEY] || '{}');
  CACHE.isLoaded = true;
  return CACHE.FILTERS;
}

const _writeToUrl = () => { 
  const location = getLocation();
  const history = getHistory();
  let queryString = clearFromQueryString(CACHE.URL_ROOT_KEY, location.search);
  if (Object.keys(CACHE.FILTERS).length) {
    queryString = createNewQueryString([CACHE.URL_ROOT_KEY, JSON.stringify(CACHE.FILTERS)], queryString);
  }

  if (history?.pushState) {
    let newUrl = location.href.split('?')[0];
    if (!isQueryStringEmpty(queryString)) {
      newUrl += queryString;
    }
    if (newUrl !== location.href) {
      history.pushState({}, '', newUrl);
    }
  } else { 
    // fallback
    location.search = !isQueryStringEmpty(queryString) ? queryString : '';
  }

}

const addToUrl = (filterKey, item) => { 
  _addToLocal(filterKey, item);
  _writeToUrl();
}

const removeFromUrl = (filterKey, item) => { 
  _removeFromLocal(filterKey, item);
  _writeToUrl();
}

const clearUrl = () => { 
  _clearLocal();
  _writeToUrl();
}

const LADF_UTIL = {
  loadCacheFromUrl,
  addToUrl,
  removeFromUrl,
  clearUrl,
  CACHE
}

export default LADF_UTIL;





